// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Attributes from 'esm-web-pro/components/layout/sidePanel/Attributes';
import { FormClose } from 'grommet-icons';
import { FormCheckmark } from 'grommet-icons/icons';


type Props = {
    nomenclatureType: Object,
    nomenclatureItemFields: Object[],
};

const NomenclatureTypeAttributes = (props: Props) => {
    const { nomenclatureType, nomenclatureItemFields } = props;

    const attributes = React.useMemo(() => {
        const attrs = [
            {
                label: <FormattedMessage id="nomenclatureitem-code" defaultMessage="Code" />,
                value: nomenclatureType.code,
            },
            {
                label: <FormattedMessage id="nomenclature-is-active" defaultMessage="Is Active" />,
                value: nomenclatureType.is_active ? <FormCheckmark /> : <FormClose />,
            },
        ];

        if (nomenclatureItemFields) {
            nomenclatureItemFields.forEach(([name, field]) => {
                if (
                    ['created', 'modified', 'is_active', 'data', 'translations', 'code'].includes(name)
                    || field.type === 'json'
                ) {
                    return;
                }

                const value = nomenclatureType[name];

                const attr = {
                    label: field.ui.label,
                    value: value || '',
                };

                if (field.type === 'boolean') {
                    attr.value = value ? <FormCheckmark /> : <FormClose />;
                } else if (field.type === 'choice' && !field.validation.many) {
                    if (value) {
                        const choice = field.ui.choices[value];
                        attr.value = choice || '';
                    }
                } else if (field.type === 'choice' && field.validation.many) {
                    if (value && value.length) {
                        attr.value = value.map((v) => {
                            const choice = field.ui.choices[v];
                            return choice || '';
                        }).filter((v) => (!!v)).join(', ');
                    }
                }

                attrs.push(attr);
            });
        }

        return attrs;
    }, [nomenclatureItemFields, nomenclatureType]);

    return <Attributes attributes={attributes} />;
};

export default NomenclatureTypeAttributes;
